import axios from "axios";
import * as actionType from "../../constant/actionType";

export const RegisterWorker = (ApiData, token) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      data: ApiData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token || localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/RegisterWorker`,
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error.message || "Failed to register workers"
    };
  }
};
